<div class="add-home-info-container">
    <div>
        <h3>Információs szöveg megadása</h3>
    </div>
    <div>
        <textarea class="input" id="textarea"></textarea>
    </div>
</div>
